import React from 'react'
import {CourseCard} from './CourseCard'

const Courses = ({courses}) => {
  return (
    <div className="p-4 flex flex-col justify-center lg:px-32">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {courses.map(course => (
          <CourseCard key={course.slug} {...course} />
        ))}
      </div>
    </div>
  )
}

export {Courses}
